// App origin: signup, login, dashboard (subdomain only). Override for staging via REACT_APP_APP_ORIGIN.
const APP_ORIGIN = (process.env.REACT_APP_APP_ORIGIN || 'https://app.appifyai.com').replace(/\/$/, '');

export const getAppUrl = (path = '') => {
  const p = path.startsWith('/') ? path : `/${path}`;
  return `${APP_ORIGIN}${p}`;
};

export const getMarketingUrl = (path = '') => {
  return `https://appifyai.com${path}`;
};

const RENDER_API = 'https://appify-ai-server.onrender.com';

/** Full API base for authenticated calls (legacy). */
export const getApiUrl = () => {
  return RENDER_API;
};

/**
 * Public API base (no auth) — demo request from marketing site, etc.
 * Localhost uses REACT_APP_API_URL or http://localhost:3001; production uses env or Render.
 */
export const getPublicApiBase = () => {
  const host = typeof window !== 'undefined' ? window.location.hostname : '';
  const local = host === 'localhost' || host === '127.0.0.1';
  const env = (process.env.REACT_APP_API_URL || '').trim();
  if (local) {
    return (env || 'http://localhost:3001').replace(/\/$/, '');
  }
  if (env && !env.includes('localhost') && !env.includes('127.0.0.1')) {
    return env.replace(/\/$/, '');
  }
  return RENDER_API;
};
